import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quagDia: IProductData = {
  id: "quag-dia",
  name: "Quagliardi Colorbox DI(A)",
  description: "500 series preamp with color options.",
  images: ["/img/quag_dia_front.png"],
  details: [{
    label: "Description",
    markdown: `
The COLORBOX DI is a sturdy stereo passive direct box equipped with Quagliardi audio transformers, whose permalloy cores provide a smooth and warm sound reminiscent of the finest vintage equipment.
They feature ground lift and a 20dB input attenuator for each channel.
`
  }, {
    label: "Specifications",
    markdown: `
- Type: Passive
- Channels: 2
- Pad: -20dB
- Enclosure Material: Aluminum
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/colorbox/" target="_blank">https://quagliardiaudio.com/colorbox/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.DI, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.MIXING],
    manufacturer: BRAND.QUAGLIARDI,
  }
}